import { render } from "./InputResearchComponent.vue?vue&type=template&id=740af0be"
import script from "./InputResearchComponent.vue?vue&type=script&lang=js"
export * from "./InputResearchComponent.vue?vue&type=script&lang=js"

import exportComponent from "/home/andre/Bureau/projets-nexah/web/vuejs/web/cv-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__